const { default: axios } = require("axios");

document.querySelectorAll(".input-box input").forEach(function (input) {
    input.addEventListener("change", function (e) {
        if (e.currentTarget.value !== "") {
            e.currentTarget.parentNode.classList.add("visited");
        } else {
            e.currentTarget.parentNode.classList.remove("visited");
        }
    });
});


function adjustHeaderHeight(category_key) {
    let h = $(this).closest(".past-bel").find(`.past-bel-image-wrapper[data-li="${category_key}"]`).height();
    $(".past-bel-image").animate({
        height: h + "px"
    }, 300, function () {
        // Animation complete.
    });
}

$(window).on('resize', () => {
    const current_target = $('.nav-item.selected:not(.multi)')[0] || $('.nav-item.selected')[0];
    if (!current_target)
        return;
    const category_key = current_target.dataset.li;
    adjustHeaderHeight(category_key);
});

$(function () {
    let i = false;
    // Assortment item click
    $('.nav-item[data-li]').mouseenter(function (e) {
        let first = $(this).parent().hasClass("past-bel-ul");
        if (first) {
            $(this).closest(".past-bel").find(`.past-bel-second ul`).hide().parent().addClass('hidden');
        }

        if (!$(this).hasClass('selected')) {
            if (first) {
                $('.past-bel').find('.selected').removeClass('selected');
            } else {
                $('.past-bel-second').find('.selected').removeClass('selected');
            }
            $(this).addClass('selected');
        }
        let current_target = e.currentTarget;
        let category_key = current_target.dataset.li;

        adjustHeaderHeight(category_key);
        // console.log($(this).closest(".past-bel").find(`.past-bel-ul [data-li="${category_key}"]`))
        if (first && $(this).closest(".past-bel").find(`.past-bel-ul [data-li="${category_key}"]`).hasClass('multi')) {
            $(this).closest(".past-bel").find(`.past-bel-second [data-ul="${category_key}"]`).show().parent().removeClass('hidden');
        }

        if (first) {
            i = category_key;
            $(this).closest(".past-bel").find(`.past-bel-image-wrapper[data-li="${category_key}"]`).removeClass("hide");
            $(this).closest(".past-bel").find(`.past-bel-image-wrapper[data-li="${category_key}"]`).siblings('.past-bel-image-wrapper').addClass("hide");
        } else {
            $(this).closest(".past-bel").find(`.past-bel-image-wrapper[data-li="${i}-${category_key}"]`).removeClass("hide");
            $(this).closest(".past-bel").find(`.past-bel-image-wrapper[data-li="${i}-${category_key}"]`).siblings('.past-bel-image-wrapper').addClass("hide");
        }
    });
    $('.nav-item[data-li]').mouseleave(function (e) {
        let current_target = e.currentTarget;
        let category_key = current_target.dataset.li;
        if (!$(this).parent().hasClass("past-bel-ul")) {
            category_key = i + '-' + category_key;
        }
        $(this).closest(".past-bel").find(`.past-bel-image-wrapper[data-li!="${category_key}"]`).addClass("hide");
    });

    $('.nav-item[data-li]').mouseenter(function () {
        $('.past-bel-image-wrapper[data-li="const"]').removeClass("hide");
        $('.past-bel-image-wrapper[data-li="const"]').siblings('.past-bel-image-wrapper').addClass("hide");
    });
    $('.nav-item[data-li]').mouseleave(function () {
        $('.past-bel-image-wrapper[data-li="const"]').addClass("hide");
        $('.past-bel-image-wrapper[data-li="const"]').siblings('.past-bel-image-wrapper').removeClass("hide");
    });

    $(document).on('click', '.product__dolyame__container.product__dolyame__container--cart', function() {
        console.log('click');
        $('.to_order_form > button[type="submit"]:not(.disabled)').click()
    })

    $(document).on('click', '.cart-more', (e) => {
        let state;
        if ($(e.target).hasClass("open")) {
            let childRow = $(e.currentTarget.closest('.cart-row-wrapper')).find(".cart-rows-hidden");
            childRow.removeClass("show");
            childRow.children().addClass("hide");
            $(e.currentTarget).removeClass("open");
            $(e.currentTarget).text("развернуть");
            state = false;
        } else {
            let childRow = $(e.currentTarget.closest('.cart-row-wrapper')).find(".cart-rows-hidden");
            childRow.addClass("show");
            childRow.children().removeClass("hide");
            $(e.currentTarget).addClass("open");
            $(e.currentTarget).text("cвернуть");
            state = true;
        }

        axios.post("/cart/update-state", {id: $(e.target).data("cart_set_id"), state});
    })

    function outtop() {
        if (window.innerWidth < 768) {
            window.addEventListener("wheel", function (e) {
                e.deltaY > 0 ? $(".header").addClass("header_outtop") : $(".header").removeClass("header_outtop"),
                    0 === window.scrollY && $(".header").removeClass("header_outtop")
            });
        }
    }

    outtop();

    let headerHeight = $("header").height();

    $('.delivery').click(function () {
        let top = $('#delivery').offset().top;
        $('body,html').animate({
            scrollTop: top - headerHeight
        }, 1000);
    });
    $('.payment').click(function () {
        var top = $('#payment').offset().top;
        $('body,html').animate({
            scrollTop: top - headerHeight
        }, 1000);
    });
    $('.garanty').click(function () {
        var top = $('#garanty').offset().top;
        $('body,html').animate({
            scrollTop: top - headerHeight
        }, 1000);
    });
    $('#reviewScroll').click(function () {
        var top = $('.product-reviews').offset().top;
        $('body,html').animate({
            scrollTop: top - headerHeight
        }, 1000);
    });
    $('.form-scroll').click(function () {
        var top = $('.contacts-opt').offset().top;
        $('body,html').animate({
            scrollTop: top - headerHeight
        }, 1000);
    });

    // https://stackoverflow.com/questions/46094912/added-non-passive-event-listener-to-a-scroll-blocking-touchstart-event
    jQuery.event.special.touchstart = {
        setup: function (_, ns, handle) {
            if (ns.includes("noPreventDefault")) {
                this.addEventListener("touchstart", handle, { passive: false });
            } else {
                this.addEventListener("touchstart", handle, { passive: true });
            }
        }
    };

    document.addEventListener('modals-loaded', () => {
        if (document.querySelector('.pp-order-final')) {
            showPopup('order-final');

            const el = document.querySelector('.pp-order-final');
            const { info, type } = el.dataset;

            if (info) {
                const event = new CustomEvent(`${type}-pay-page`, { detail: JSON.parse(info) })
                document.dispatchEvent(event)
            }
        }
    })
});
